import React from "react";

const TickIcon = ({ size = 29, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 29 29"
    fill="none"
    {...props}
  >
    <path
      d="M14.4994 26.5846C21.1452 26.5846 26.5827 21.1471 26.5827 14.5013C26.5827 7.85547 21.1452 2.41797 14.4994 2.41797C7.85352 2.41797 2.41602 7.85547 2.41602 14.5013C2.41602 21.1471 7.85352 26.5846 14.4994 26.5846Z"
      stroke="#07BC0C"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="14.5003" cy="14.5003" r="11.3929" fill="#07BC0C" />
    <path
      d="M8.39648 14.7225L12.4412 18.7672L20.545 10.6777"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TickIcon;
